export const SET_AUTHENTICATION = 'authentication/set';
export const UPDATE_AUTHENTICATION = 'authentication/update';
export const RESET_AUTHENTICATION = 'authentication/reset';
